import { MediaMatcher } from '@angular/cdk/layout';
import { ChangeDetectorRef, Component } from '@angular/core';
import { OAuthService } from 'angular-oauth2-oidc';
import { AppTokenService } from '@synx-cloud/services';

@Component({
    selector: 'home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.scss'],
    standalone: false
})
export class HomeComponent {
  mobileQuery: MediaQueryList;
  private _mobileQueryListener: () => void;
  helpToggled = false;

  navOptions = [
    { name: 'Customer Management', route: 'customer-management' },
    { name: 'Device Management', route: 'device-management' },
  ];

  /**
   * CTOR
   * @param {ChangeDetectorRef} changeDetectorRef
   * @param {MediaMatcher} media
   */
  constructor(changeDetectorRef: ChangeDetectorRef, media: MediaMatcher, private oAuthService: OAuthService, private appTokenService: AppTokenService) {
    this.mobileQuery = media.matchMedia('(max-width: 600px)');
    this._mobileQueryListener = () => changeDetectorRef.detectChanges();
    this.mobileQuery.addListener(this._mobileQueryListener);
  }

  logout() {
      this.oAuthService.logOut();
      this.appTokenService.clear();
      this.oAuthService.revokeTokenAndLogout();
  }

  onHelpToggledChange(showHelp: boolean){
    this.helpToggled = showHelp;
  }
}
